import React from 'react'
import Modal from '@components/Common/Modal'
import { ModalProps } from '@interfaces/Modal'
import TableCarreta from '../Table'
import Button from '@components/Common/Button'

const ModalCarreta: React.FC <ModalProps> = props => {

    return(

        <Modal
            {...props}
            title = "Buscar carreta"
            width = "100%"
        >
            <TableCarreta {...props} />
            <div className='ml-auto mt-4'>
                <Button
                    label="Fechar"
                    onClick={() => props.setOpen(false)}
                />
            </div>
        </Modal>

    )

}

export default ModalCarreta